import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/store";
import { getProfileInfo } from "../../../redux/profile/settings/getProfileInfo/selectors";
import { fetchProfileInfo } from "../../../redux/profile/settings/getProfileInfo/asyncActions";
import {
  fetchEditEmail,
  fetchEditName,
  fetchEditPhone,
} from "../../../redux/profile/settings/changeDataProfile/asyncActions";
import { Button } from "../../../components";
import { Modal } from "../../../components";
import styles from "./EditMyProfileScreen.module.scss";

import passwordIcon from "../../../assets/icons/changePasswordIcon.svg";
import trashIcon from "../../../assets/icons/trashIconFitnes.svg";
import arrowIcon from "../../../assets/icons/arrowMenuRight.svg";

interface FormData {
  name: string;
  phone: string;
  email: string;
}

export const EditMyProfileScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { profileInfo } = useSelector(getProfileInfo);
  const user = profileInfo && profileInfo.length > 0 ? profileInfo[0] : null;

  const [form, setForm] = useState<FormData>({
    name: "",
    phone: "",
    email: "",
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    dispatch(fetchProfileInfo());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        phone: user.phone || "",
        email: user.email || "",
      });
    }
  }, [user]);

  const deletePhoneSymbol = (phone: string): string => {
    return phone.replace(/\D/g, "");
  };

  const isDisabled =
    user &&
    form.name === user.name &&
    deletePhoneSymbol(form.phone) === deletePhoneSymbol(user.phone) &&
    form.email === user.email;

  const handleSave = async () => {
    if (!user) return;

    const phoneTemp = `+${form.phone.replace(/\D/g, "")}`;

    try {
      if (form.name !== user.name) {
        await dispatch(fetchEditName({ name: form.name }));
      }

      if (form.email !== user.email) {
        await dispatch(fetchEditEmail({ email: form.email }));
      }

      if (deletePhoneSymbol(form.phone) !== deletePhoneSymbol(user.phone)) {
        await dispatch(fetchEditPhone({ phone: phoneTemp, code: 0 }));
      }

      await dispatch(fetchProfileInfo());
      navigate(-1);
    } catch (error) {
    }
  };

  const handleDelete = async () => {
    setShowDeleteModal(false);
    navigate("/");
  };

  if (!user) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Загрузка...</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        {/* Поле Имя */}
        <div className={styles.inputGroup}>
          <label className={styles.label}>Ваше имя</label>
          <input
            type="text"
            className={styles.input}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Ваше имя"
          />
        </div>

        {/* Поле Телефон */}
        <div className={styles.inputGroup}>
          <label className={styles.label}>Телефон</label>
          <input
            type="tel"
            className={styles.input}
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            placeholder="Ваш номер телефона"
          />
        </div>

        {/* Поле Email */}
        <div className={styles.inputGroup}>
          <label className={styles.label}>E-mail</label>
          <input
            type="email"
            className={styles.input}
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="Ваш email"
          />
        </div>
      </div>

      <div className={styles.buttonContainer}>
        {/* Кнопка смены пароля */}
        <button
          className={styles.button}
          onClick={() =>
            navigate("/profile/change-password", {
              state: { phone: user.phone, profileScreen: true },
            })
          }
        >
          <div className={styles.buttonContent}>
            <img
              src={passwordIcon}
              alt="Сменить пароль"
              className={styles.buttonIcon}
            />
            <span className={styles.buttonText}>Сменить пароль</span>
          </div>
          <img src={arrowIcon} alt="" className={styles.buttonIcon} />
        </button>

        {/* Кнопка сохранения */}
        <Button
          onClickFunc={handleSave}
          newStyles={isDisabled ? styles.disabledButton : styles.saveButton}
        >
          Сохранить
        </Button>
      </div>

      {/* Кнопка удаления аккаунта */}
      <div className={styles.deleteContainer}>
        <button
          className={styles.deleteButton}
          onClick={() => setShowDeleteModal(true)}
        >
          <img src={trashIcon} alt="Удалить" className={styles.deleteIcon} />
          <span className={styles.deleteText}>Удалить аккаунт</span>
        </button>
      </div>

      {/* Модальное окно подтверждения удаления */}
      {showDeleteModal && (
        <Modal
          title="Удаление аккаунта"
          isOpen={showDeleteModal}
          setIsOpen={setShowDeleteModal}
          subTitle="Ваша заявка на удаление аккаунта отправлена в техническую поддержку"
        >
          <div className={styles.modalButtons}>
            <Button onClickFunc={handleDelete}>Готово</Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

